import { gql } from '@apollo/client';

export const REGISTER_META_TOKEN = gql`
  mutation register_meta_account($data: RegisterMetaAccountInputType) {
    register_meta_account(data: $data) {
      hasError
      data
      message
    }
  }
`;
